import Disturber from "./Disturber";

export default function () {
    return <Disturber>
        <p>
            Um den Tarif zu wechseln, müssen Sie Ihre bestehende Mitgliedschaft kündigen.
            Gern übernehmen wir das für Sie.
        </p>
    </Disturber>
}
